import React, { memo } from 'react'

import { SectionTabs, Panel } from './Subtabs'
import EventorInvoiceImport from './EventorInvoiceImport'
import PrepaidCompetitionSync from './PrepaidCompetitionSync'
import EventorMemberImport from './EventorMemberImport'
import { useHasCapability } from './Capabilities'

// The three Eventor-sync areas under one tab, each sub-tab shown only if the role holds its
// capability. `active` (the parent tab's active state) is forwarded to the visible sub-tab so a
// panel can act on first activation — e.g. Förskottstävlingar pre-loads its payment events.
// memo: MainNavigation re-renders on every tab switch; without this the whole Eventor subtree would
// reconcile each time even when the switch doesn't involve this tab (props are stable — active only
// flips when this tab is entered/left).
const EventorSyncTab = memo(function EventorSyncTab({ active, onUpdate }: { active: boolean, onUpdate: () => void }) {
    const canInvoices = useHasCapability('eventor.import_invoices')
    const canPayments = useHasCapability('eventor.register_payments')
    const canMembers = useHasCapability('member.import')

    const subtabs: Panel[] = []
    if (canInvoices) subtabs.push({ slug: 'vanliga', label: 'Vanliga tävlingar', panel: () => <EventorInvoiceImport onUpdate={onUpdate}/> })
    if (canPayments) subtabs.push({ slug: 'forskott', label: 'Förskottstävlingar', panel: a => <PrepaidCompetitionSync active={a}/> })
    if (canMembers) subtabs.push({ slug: 'medlemmar', label: 'Medlemmar', panel: () => <EventorMemberImport/> })

    return <SectionTabs panels={subtabs} active={active}/>
})

export default EventorSyncTab
